<template>
  <div class="mobile-login-page">
    <div class="login-header">
      <div class="company-name">申远物流</div>
      <div class="subtitle">快递调度平台</div>
    </div>

    <div class="login-form">
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="top"
        @submit.prevent
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入账号"
            autocomplete="username"
            @keyup.enter="onSubmit"
          />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter="onSubmit"
          />
        </el-form-item>

        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="onSubmit"
        >
          登录
        </el-button>
      </el-form>
    </div>

    <div class="footer">上海申远特种线缆股份有限公司</div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { apiUrl } from '../api/config'

export default {
  name: 'MobileLoginPage',
  emits: ['success'],
  setup(_, { emit }) {
    const formRef = ref(null)
    const loading = ref(false)

    const form = reactive({
      username: '',
      password: ''
    })

    const rules = {
      username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
    }

    const onSubmit = async () => {
      if (loading.value) return

      const ok = await formRef.value?.validate?.().catch(() => false)
      if (!ok) return

      loading.value = true
      try {
        const url = apiUrl('/Api/Auth/Login')
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userName: form.username,
            password: form.password
          })
        })

        const json = await res.json()

        // 处理不同的响应码
        if (json.code === 0) {
          // 登录成功
          const data = json.data
          localStorage.setItem('token', data.token)
          localStorage.setItem('userName', data.userName)
          localStorage.setItem('expireAt', data.expireAt)
          localStorage.setItem('isAdmin', String(data.isAdmin === true))

          ElMessage.success('登录成功')
          emit('success', { username: data.userName, token: data.token })
        } else if (json.code === 1) {
          // 密码需修改
          ElMessage.warning(json.message || '密码不符合规则，请先登录ERP系统修改密码')
        } else {
          // 其他错误
          ElMessage.error(json.message || '用户名或密码错误')
        }
      } catch (e) {
        ElMessage.error('登录失败，请稍后重试')
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      form,
      rules,
      loading,
      onSubmit
    }
  }
}
</script>

<style scoped>
.mobile-login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #1890ff 0%, #096dd9 100%);
}

.login-header {
  padding: 60px 24px 40px;
  text-align: center;
}

.company-name {
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.login-form {
  flex: 1;
  padding: 24px;
  background: #fff;
  border-radius: 24px 24px 0 0;
}

.login-form :deep(.el-form-item__label) {
  color: #333;
  font-size: 14px;
}

.login-form :deep(.el-input__wrapper) {
  border-radius: 8px;
}

.login-btn {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
  margin-top: 8px;
}

.footer {
  padding: 16px;
  text-align: center;
  font-size: 12px;
  color: #999;
  background: #fff;
}
</style>
